var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.429,
    height: 17.463,
    viewBox: "0 0 17.429 17.463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6822",
    "data-name": "Group 6822",
    transform: "translate(-1129.977 -1805.352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8905",
    "data-name": "Path 8905",
    d: "M361,825.7a.672.672,0,0,1-.672-.672.648.648,0,0,1,.012-.127l1.052-5.434a.673.673,0,0,1,1.135-.348l4.346,4.347a.672.672,0,0,1-.342,1.134l-5.4,1.086a.645.645,0,0,1-.133.013m1.471-4.735-.621,3.208,3.188-.642Z",
    transform: "translate(769.648 997.111)",
    fill: "#003189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8906",
    "data-name": "Path 8906",
    d: "M366.483,823.774a.669.669,0,0,1-.475-.2l-4.347-4.346a.673.673,0,0,1,0-.951L372.1,807.836a1.5,1.5,0,0,1,2.119,0l3.179,3.179a1.5,1.5,0,0,1,0,2.118l-10.445,10.444a.665.665,0,0,1-.475.2m-3.4-5.018,3.4,3.4,9.968-9.969a.155.155,0,0,0,0-.219l-3.178-3.177a.155.155,0,0,0-.219,0Z",
    transform: "translate(769.566 997.953)",
    fill: "#003189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8907",
    "data-name": "Path 8907",
    d: "M376.383,814.72a.668.668,0,0,1-.475-.2l-4.347-4.347a.672.672,0,0,1,.95-.95l4.348,4.347a.673.673,0,0,1-.475,1.147",
    transform: "translate(768.842 997.834)",
    fill: "#003189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8908",
    "data-name": "Path 8908",
    d: "M364.481,821.891a.671.671,0,0,1-.475-1.146l9.176-9.176a.672.672,0,0,1,.95.951l-9.176,9.176a.67.67,0,0,1-.475.2",
    transform: "translate(769.395 997.664)",
    fill: "#003189"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconBlue);
export default __webpack_public_path__ + "static/media/edit-icon-blue.1b9790f8f6ebe6c642736d2a4a47ed3f.svg";
export { ForwardRef as ReactComponent };